/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Radio } from "@mui/material";
import { Typography, Grid, Button } from "@financeable-com-au/financeable-ui";
import { OwnershipUsersModelProps } from "@/utils/interface";
// @ts-expect-error: ignoring as it is existing js file
import DataGridTable from "../dataGridTable/DataGridTable";

const OwnershipUsersModel = ({
  handleClose,
  handleAssignOwnership,
  ownershipUsersList,
  open,
  gettingUsers,
  isAssigningOwnership,
}: OwnershipUsersModelProps) => {
  const [params, setParams] = useState({ offset: 1 });
  const [selectedRow, setSelectedRow] = useState({
    id: "",
    data: null,
  });

  const handleRowSelection = ({ id, data }: { id: string; data: any }) => {
    setSelectedRow({
      id: id,
      data: data,
    });
  };

  const ownershipUsersColumns = [
    {
      field: "select",
      headerName: "Select",
      width: 100,
      renderCell: (params: any) => (
        <Radio
          checked={params.row?._id === selectedRow?.id}
        />
      ),
    },
    {
      field: "firstName",
      headerName: "First name",
      type: "string",
      width: 170,
      sortable: true,
      editable: false,
    },
    {
      field: "lastName",
      headerName: "Last name",
      type: "string",
      width: 170,
      editable: false,
    },
    {
      field: "email",
      headerName: "Email",
      type: "string",
      width: 270,
      editable: false,
      renderCell: (params: any) => (
        <div>
          <Typography style={{ fontSize: "14px" }}>{params?.value?.address}</Typography>
        </div>
      ),
    },
  ];

  const handle = {
    assignOwnershipHandler: async () => {
      if (!selectedRow.id) return;
      handleAssignOwnership(selectedRow.id);
      setSelectedRow({
        id: "",
        data: null,
      });
    },
  };

  const getRowId = (row: any) => row["_id"];

  return (
    <div>
      <Dialog fullWidth maxWidth={"md"} open={open} onClose={handleClose} disableEscapeKeyDown={true} PaperProps={{
        style: {
          borderRadius: "10px",
        },
      }}>
        <DialogTitle
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography level="title-md">User List</Typography>
        </DialogTitle>

        <DialogContent>
          <Grid style={{ maxHeight: 420, width: "100%" }}>
            <DataGridTable
              data={ownershipUsersList || []}
              columns={ownershipUsersColumns}
              onRowClick={(data: any) => {
                handleRowSelection({
                  id: data?._id,
                  data: data,
                });
              }}
              rowsPerPageOptions={[10]}
              pageSize={50}
              rowCount={ownershipUsersList?.length || 0}
              params={params}
              setParams={setParams}
              page={1}
              isLoading={gettingUsers}
              getRowId={getRowId}
              isHideTableFooter={true}
            />
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: "0 20px 20px 0" }}>
          <Button onClick={handleClose} variant="secondary">
            Cancel
          </Button>
          <Button
            disabled={!selectedRow?.id || isAssigningOwnership}
            onClick={handle.assignOwnershipHandler}
            variant="primary"
          >
            {isAssigningOwnership ? "Assigning..." : "Assign"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OwnershipUsersModel;
